import { ReactElement } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Checkbox, XIcon } from '@weareopenr/component-library';
import { IRange } from 'src/api/getRanges';
import styles from './RangesField.module.scss';

interface RangesFieldProps {
  ranges: IRange[];
  isLoading: boolean;
  value: string[];
  onChange: (rangeIds: string[]) => void;
  error?: string;
}

export const RangesField = ({ ranges, isLoading, value, onChange, error }: RangesFieldProps): ReactElement => {
  const selectedRanges = ranges.filter((range) => value.includes(range.range_id));

  return (
    <Autocomplete<IRange, true, false, false>
      multiple
      disableCloseOnSelect
      loading={isLoading}
      options={ranges}
      value={selectedRanges}
      isOptionEqualToValue={(option, val) => option.range_id === val.range_id}
      getOptionLabel={(option) => option.name}
      onChange={(_, data) => onChange(data.map((range) => range.range_id))}
      limitTags={4}
      ChipProps={{ deleteIcon: <XIcon size="xsmall" /> }}
      renderInput={(params) => (
        <TextField size="xsmall" {...params} label="Ranges" error={!!error} helperText={error} />
      )}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.range_id}>
          <Checkbox checked={selected} onChange={() => {}} />
          {option.name}
        </li>
      )}
      className={styles['autocomplete']}
    />
  );
};

export default RangesField;
